module.exports = __webpack_public_path__ + "5b8ce8fe6674f950ce0eb0e46dc32172.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/759.png
// module id = 1692
// module chunks = 2